/*
 * File: d:\projects\AutoFiFront\public\BrandSvg\DACIA.tsx
 * Project: d:\projects\AutoFiFront
 * Created Date: Friday March 10th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Friday March 10th 2023 5:04:46 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 * HISTORY:
 */


import { SVGProps } from 'Content/SVG/SVGProps';

function DACIA(props: SVGProps) {
    return(
        <svg id="Calque_1" fill={props.fill} data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1080 1080">
            <path d="M111.94,420.35v79.54H406.32v80.21H111.94v79.54H436.97c7.46,0,12.37-2.07,17.45-7.18l85.58-83.24,85.58,83.24c5.08,5.11,10,7.18,17.45,7.18h325.03v-79.54h-294.38v-80.21h294.38v-79.54h-325.03c-7.46,0-12.37,2.07-17.45,7.18l-85.58,83.24-85.58-83.24c-5.08-5.11-10-7.18-17.45-7.18H111.94Z"/>
        </svg>
    );
}

export default DACIA;
